var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-snackbar",
    {
      staticClass: "md-accent",
      attrs: {
        "md-position": _vm.config.position,
        "md-duration": Infinity,
        "md-active": _vm.isActive,
        "md-persistent": ""
      },
      on: {
        "update:mdActive": function($event) {
          _vm.isActive = $event
        },
        "update:md-active": function($event) {
          _vm.isActive = $event
        }
      }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.config.msg))]),
      _vm._v(" "),
      _vm.config.showButton
        ? _c(
            "md-button",
            {
              staticClass: "md-primary",
              on: {
                click: function($event) {
                  _vm.isActive = false
                }
              }
            },
            [_vm._v("\n    " + _vm._s(_vm.config.btnText) + "\n  ")]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc5db7a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc5db7a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/common/messages/LoaderBar.vue
// module id = UfSx
// module chunks = 1